import './quick-shop-look.scss';

(function () {
  const QBSLButtons = document.querySelectorAll('.quick-shop-look__tooltip-button');

  if(QBSLButtons && QBSLButtons.length) {
    Array.from(QBSLButtons).map(el => {
      el.addEventListener('click', function(e){
        const shopLookItem = e.target.closest('.quick-shop-look__tooltip-item');

        if(shopLookItem) {
          const QSButton = shopLookItem.querySelector('[data-qb-button]');

          if(QSButton) {
            const proxyClick = new CustomEvent('click');
            QSButton.dispatchEvent(proxyClick);
          }
        }
      });
    });
  }
})();
